import React, { useState } from 'react';
import {
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import resBlack from './../../../assets/icons/analysis.png';
import productBlack from './../../../assets/icons/product (1).png';
import empBlack from './../../../assets/icons/Emp.png';
import order from './../../../assets/icons/order.png';
import products from './../../../assets/icons/products.png';
import settingIMG from './../../../assets/icons/settings.png';
import Delivery from '../../../assets/icons/delivery.png';
import OrderHistoryLog from '../../../assets/icons/order-history.png';
import Divider from '@mui/material/Divider';
import restaurantIcon from "../../../assets/icons/restaurantBlack.png";
import menu from "../../../assets/icons/menu.png";
import cargo from "../../../assets/icons/cargo.png";
import item from "../../../assets/icons/Item.png";

const clickMenuList = (props) => {
  console.log('props: ' + props);

  if (props === 'Dashboard') {
    // navigate("/orders");
    window.location.href = '/';
  } else if (props === 'Menu') {
    // navigate("/manage-product");
    window.location.href = '/manage-product';
  } else if (props === 'Kitchens') {
    // navigate("/orders");
    window.location.href = '/orders';
  } else if (props === 'Delivery') {
    // navigate("/orders");
    window.location.href = '/delivery';
  } else if (props === 'Restaurant') {
    // navigate("/restaurant-setup");
    window.location.href = '/restaurant-setup';
  } else if (props === 'Settings') {
    // navigate("/admin-dashboard");
    window.location.href = '/admin-dashboard';
  } else if (props === 'Company') {
    window.location.href = '/admin-settings';
  } else if (props === 'Transactions Log') {
    window.location.href = '/order-history-log';
  }
};

function SideBar(props) {
  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer =
    (anchor: any) => (event: React.KeyboardEvent | React.MouseEvent) => {
      console.log(
        '(event as React.KeyboardEvent).key: ' +
        (event as React.KeyboardEvent).key
      );
      console.log('event: ' + event);
      if (
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return;
      }

      setState((prevState) => ({
        ...prevState,
        [anchor]: !prevState[anchor],
      }));
    };

  const list = (anchor: any) => (
    <Box
      sx={{
        width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250,
        marginTop: 5,
      }}
      role='presentation'
      onClick={toggleDrawer(anchor)}
      onKeyDown={toggleDrawer(anchor)}
    >
      <List>
        {['Dashboard', 'Restaurant', 'Menu'].map(
          (text, index) => (
            <ListItem
              key={text}
              disablePadding
              onClick={() => clickMenuList(text)}
            >
              <ListItemButton>
                <ListItemIcon>
                  {index === 0 ? (
                    <img
                      src={resBlack}
                      style={{ width: '1.5rem' }}
                      alt={`list-${index}`}
                    />
                  ) : index === 1 ? (
                    <img
                      src={restaurantIcon}
                      style={{ width: '1.5rem' }}
                      alt={`list-${index}`}
                    />
                  ) : index === 2 ? (
                    <img
                      src={menu}
                      style={{ width: '1.5rem' }}
                      alt={`list-${index}`}
                    />
                  ) : index === 3 ? (
                    <img
                      src={cargo}
                      style={{ width: '1.5rem' }}
                      alt={`list-${index}`}
                    />
                  ) : index === 4 ? (
                    <img
                      src={OrderHistoryLog}
                      style={{ width: '1.5rem' }}
                      alt={`list-${index}`}
                    />
                  ) : index === 5 ? (
                    <img
                      src={Delivery}
                      style={{ width: '1.5rem' }}
                      alt={`list-${index}`}
                    />
                  ) : (
                    <img
                      src={item}
                      style={{ width: '1.5rem' }}
                      alt={`list-${index}`}
                    />
                  )}
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItemButton>
            </ListItem>
          )
        )}
      </List>
      <Divider />
      {/* <List>
        {['Settings'].map((text, index) => (
          <ListItem
            key={text}
            disablePadding
            onClick={() => clickMenuList(text)}
          >
            <ListItemButton>
              <ListItemIcon>
                {index === 0 ? (
                  <img src={settingIMG} style={{ width: '1.5rem' }} alt='' />
                ) : (
                  ''
                )}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List> */}
    </Box>
  );

  return (
    <div>
      <React.Fragment key={'left'}>
        <IconButton
          onClick={toggleDrawer('left')}
          sx={{ zIndex: 1201, marginLeft: '0.5rem' }}
        >
          <MenuIcon style={{ color: state['left'] ? '#56595b' : 'white' }} />
        </IconButton>
        <Drawer
          anchor={'left'}
          open={state['left']}
          onClose={toggleDrawer('left')}
          sx={{ marginTop: '5rem' }}
        >
          {list('left')}
        </Drawer>
      </React.Fragment>
    </div>
  );
}

export default SideBar;
